import { useState } from 'react';
import type { SalesMetricType } from '@api';

export type OnClickEventType = {
  dataIndex?: number;
};

type UseTimelineComparisonArgsType = {
  salesTimeline: SalesMetricType[];
};

type UseTimelineComparisonReturnType = {
  clearComparison: () => void;
  handleClick: (event: OnClickEventType) => void;
  increaseBetweenSelectedData: number | null;
  selectedDate1: string | null;
  selectedDate2: string | null;
};

export const useTimelineComparison = ({
  salesTimeline,
}: UseTimelineComparisonArgsType): UseTimelineComparisonReturnType => {
  const [selectedDataIndizes, setSelectedDataIndizes] = useState<number[]>([]);

  const handleClick = (event: OnClickEventType) => {
    if (event.dataIndex === undefined) return;
    if (selectedDataIndizes.length < 2) {
      setSelectedDataIndizes([...selectedDataIndizes, event.dataIndex]);
    } else {
      setSelectedDataIndizes([event.dataIndex]);
    }
  };

  const selectedData = selectedDataIndizes
    .map((index) => salesTimeline[index])
    .sort((a, b) => a.date.localeCompare(b.date));

  const comparisonIsReady = selectedData.length === 2;

  const increaseBetweenSelectedData = comparisonIsReady
    ? selectedData[1].salesTotal - selectedData[0].salesTotal
    : null;

  const clearComparison = () => {
    setSelectedDataIndizes([]);
  };

  return {
    clearComparison,
    handleClick,
    increaseBetweenSelectedData,
    selectedDate1: selectedData[0]?.date ?? null,
    selectedDate2: selectedData[1]?.date ?? null,
  };
};
